
import React, { useEffect, useState, useContext } from "react";
import { LocationContext } from "../../../context/LocationContext.js";
import { useNavigate } from "react-router-dom";
import { Chip, Dialog, Drawer } from "@mui/material";
import AddItem from "./posMenuSubComponents/AddItem.jsx";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import useApiData from "../../../services/useApiData.js"
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid"
import SnackbarEx from "../../Helpers/SnackbarEx.jsx";
import MenuActionsButton from "./MenuActionsButton.jsx";
import GetData from "../../../services/GetData.js";
import EditMenuIngredients from "./posMenuSubComponents/EditMenuIngredients.jsx";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import RefreshPOSMenu from "../HelperDialogs/RefreshPOSMenu.jsx";
import DeleteData from "../../../services/DeleteData.js";
import ConfirmDelete from "../HelperDialogs/ConfirmDelete.jsx";
import DisplayIngredients from "./posMenuSubComponents/DisplayIngredients.jsx";
import DisplayModifiers from "./posMenuSubComponents/DisplayModifiers.jsx";
import EditIcon from '@mui/icons-material/Edit';
import NoRecipeItems from "../HelperDialogs/NoRecipeItems.jsx";
import CopyMenuItemRecipes from "../HelperDialogs/CopyMenuItemRecipes.jsx";
import WasteFactorConf from "../HelperDialogs/WasteFactorConf.jsx";
import UpdateInventoryCount from "./UpdateInventoryCount.jsx";
import { useUpdateInventoryCount } from '../../../services/inventoryService.js';
import { Stack } from '@mui/material';
import { dataGridSx, quickFilterSx } from '../../ui/dataGridStyles.js';
import { tokens } from '../../../theme.js';

const apiUrl = "api/menuItems"
const apiRecipeUrl = "api/menuItemsRecipes"

export default function PosMenu({ reload }) {
    const navigate = useNavigate();
    const { isDummyLocation, location } = useContext(LocationContext)
    const [openAddItem, setOpenAddItem] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState({
        color: "",
        message: "",
        open: false
    })
    const [row, setRow] = useState([])
    const [col, setCol] = useState([])
    const [ingredientsHeader, setIngredientsHeader] = useState(null)
    const [selSingleIngredient, setSelSingleIngredient] = useState(null)

    const [selIngrIdArr, setSelIngrIdArr] = useState(null)

    const [selCategory, setSelCategory] = useState(null)

    const [reloadData, setReloadData] = useState(false)

    const [openEdit, setOpenEdit] = useState(false)
    const [deleteIcon, setDeleteIcon] = useState(false)
    const [posOpen, setPosOpen] = useState(false)
    const [openWasteFactor, setOpenWasteFactor] = useState(false)
    const [copyRecipeOpen, setCopyRecipeOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [date1, setDate1] = useState(null)
    const [date2, setDate2] = useState(null)
    const [load, setLoad] = useState(true)
    const [posLoad, setPosLoad] = useState(false)

    const [noRecipeItem, setNoRecipeItem] = useState({
        "openDialog": false,
        "itemNames": null
    })

    /*Fetches the data menu items to be displayed in the table below */
    const { data: menuItemsData, error: menuItemsError, isLoading: menuItemsLoading, refetch: refetchMenuItems } = useApiData(apiUrl);
    // Using useApiData (which now wraps useQuery) for recipes
    const { data: recipes, error: recipesError, isLoading: recipesLoading, refetch: refetchRecipes } = useApiData(apiRecipeUrl);

    // Combine loading states
    const isLoading = menuItemsLoading;

    //This is going to handle the pop up to add a menu item to the database
    const handlePopupClose = async (close, success) => {

        setOpenAddItem(false)
        if (close === 'close') {
            setOpenAddItem(close)
            setNoRecipeItem(cur => ({ ...cur, ["openDialog"]: false }))
        }
        else if (success === 'success') {
            setOpenSnackbar({ color: "success", message: "Item Added Successfully!", open: true })
            setReloadData(true)
            setOpenEdit(false)
            refetchMenuItems()
        } else if (success === 'copied') {
            setCopyRecipeOpen(false)
            setOpenSnackbar({ color: "success", message: "Item Copied Successfully!", open: true })
            setReloadData(true)
            refetchMenuItems()
        }
        else if (success === 'error') {
            setOpenEdit(false)
            setOpenSnackbar({ color: "error", message: "An Error Occurred.", open: true })
        }
        else if (!close) {
            setCopyRecipeOpen(false)
            setOpenEdit(false)
        } else {
            setNoRecipeItem(cur => ({ ...cur, ["openDialog"]: false, ["itemNames"]: null }))
            refetchMenuItems()
        }
    }

    // const refreshPage = () => {        
    //     setReloadData(true)
    //     setTimeout(() => {
    //         // Code to be executed after the delay
    //         setReloadData(false)
    //     }, 200);
    // }

    useEffect(() => {
        if (menuItemsData) {
            setData()
            setLoad(false)
        }
    }, [menuItemsData, recipes]) // Depend on menuItemsData and recipes from useQuery

    const { mutate: updateInventory } = useUpdateInventoryCount();

    const handleInventoryChange = (id, newValue, change) => {
        console.log(id, newValue)
        if (change) {
            return updateInventory({ id, invOnHand: newValue }, {
                onSuccess: () => {
                    refetchMenuItems(); // Trigger re-fetch for menu items
                    // If recipe data is also affected and needs refresh:
                    // refetchRecipes(); // Trigger re-fetch for recipes
                    setOpenSnackbar({ color: "success", message: "Inventory updated!", open: true });
                },
                onError: (error) => {
                    console.error("Error updating inventory from PosMenu:", error);
                    setOpenSnackbar({ color: "error", message: "Error updating inventory.", open: true });
                }
            });
        }
    };
    const setData = () => {
        if (!menuItemsData) { // Add a check for undefined or null
            console.warn("menuItemsData is undefined or null. Skipping setRow.");
            setRow([]); // Initialize with an empty array to prevent further errors
            return;
        }
        setRow(menuItemsData.map(e => {

            const itemIngredients = recipes?.find(ing => ing.posMenuItemId === e.itemId);
            const recipeLines = itemIngredients?.ingredients || [];
            const requiresSupplies = typeof e.requiresSupplies === 'boolean'
                ? e.requiresSupplies
                : recipeLines.length > 0;

            const prodCost = itemIngredients?.productionCost || e.productionCost || 0.0;
            const wasteFactor = itemIngredients?.wasteFactor || 0.0;
            const margin = e.salePrice > 0
                ? ((e.salePrice - prodCost) / e.salePrice) * 100
                : null;

            return {
                id: e._id,
                itemImg: e?.itemImage?.thumbnailImg ?? "/images/camera.svg",
                col1: e.itemName,
                col2: e.variant ? e.variant : 'None',
                col3: e.category,
                requiresSupplies,
                cogs: Number(prodCost) || 0,
                margin,
                salePrice: e.salePrice,
                invOnHand: e.availForSale,
                allocatedInv: e.allocatedInv || 0,
                sellStatus: e.sellStatus,
                posItemId: e.posItemId,
                itemId: e.itemId,
                wasteFactor,
                shopifyVariantId: (() => {
                    const shopify = (Array.isArray(e.salesChannel) ? e.salesChannel : [])
                        .find((c) => String(c?.name || '').toLowerCase() === 'shopify');
                    if (shopify?.varId != null) return String(shopify.varId);
                    const ext = (Array.isArray(e.externalIdentifier) ? e.externalIdentifier : [])
                        .find((x) => String(x?.vendor || '').toLowerCase() === 'shopify');
                    if (ext?.identifier) return String(ext.identifier);
                    const pos = e.posItemId;
                    if (pos != null && !String(pos).startsWith('local-')) return String(pos);
                    return null;
                })(),
            }
        }));

        setCol([
            {
                field: 'itemImg', headerName: '', minWidth: '35', maxWidth: '50',
                renderCell: (params) => (
                    <div className="grid-cell-wrap"
                        style={{
                            whiteSpace: "normal", wordWrap: "break-word",
                            overflow: "hidden", textOverflow: "ellipsis",
                            lineHeight: "1.2em", maxHeight: "2.4em"
                        }}>
                        <img src={params.value} height={"30px"} width={"30px"} alt="" />
                    </div>
                )
            },
            {
                field: 'col1', headerName: 'Item Name', minWidth: '275',
                renderCell: (params) => (
                    <div className="grid-cell-wrap"
                        style={{
                            whiteSpace: "normal", wordWrap: "break-word",
                            overflow: "hidden", textOverflow: "ellipsis",
                            lineHeight: "1.2em", maxHeight: "2.4em"
                        }}>
                        <CustomFieldRender value={params.value} />
                    </div>
                )
            },
            {
                field: 'col2', headerName: 'Full Variant Name', minWidth: '220',
                renderCell: (params) => (
                    <div className="grid-cell-wrap"
                        style={{
                            whiteSpace: "normal", wordWrap: "break-word",
                            overflow: "hidden", textOverflow: "ellipsis",
                            lineHeight: "1.2em", maxHeight: "2.4em"
                        }}>
                        <CustomFieldRender value={params.value} />
                    </div>
                )
            },
            { field: 'col3', headerName: 'Cost Category', minWidth: '140' },
            {
                field: 'requiresSupplies', headerName: 'Type', minWidth: '100',
                renderCell: (params) => (
                    <Chip
                        size="small"
                        label={params.value ? 'Made' : 'Whole'}
                        sx={{
                            bgcolor: params.value ? '#E7F0E7' : '#F1EBE3',
                            color: params.value ? '#5B7F5E' : '#8B7355',
                            fontWeight: 600,
                        }}
                    />
                )
            },
            {
                field: 'cogs', headerName: 'COGs', minWidth: '100',
                valueFormatter: ({ value }) => `$ ${Number(value || 0).toFixed(2)}`
            },
            {
                field: 'salePrice', headerName: "Sale Price", minWidth: '100', valueFormatter: ({ value }) =>
                    value ? `$ ${value.toFixed(2)}` : '$ ' + 0.0
            },
            {
                field: 'margin', headerName: "Margin", minWidth: '90',
                valueFormatter: ({ value }) => (value == null || Number.isNaN(value) ? '—' : `${value.toFixed(1)}%`)
            },
            {
                field: 'invOnHand', headerName: "Sellable Inventory", minWidth: '120',
                renderCell: (params) => <UpdateInventoryCount {...params} updateCount={handleInventoryChange} />
            },
            { field: 'allocatedInv', headerName: "Allocated Inventory", minWidth: '50' },
            {
                field: 'shopifyVariantId',
                headerName: 'Shopify variant',
                minWidth: 140,
                renderCell: (params) => (
                    <span style={{ fontSize: 13, color: params.value ? undefined : '#9a9188' }}>
                        {params.value || 'Not linked'}
                    </span>
                ),
            },
            {
                field: 'sellStatus', headerName: 'Sell Status', minWidth: '145', renderCell: (params) => {
                    const color = {
                        'ACTIVE': 'success',
                        'DRAFT': 'primary',
                        'ARCHIVE': 'warning'
                    }
                    return <Chip
                        size="small"
                        label={params.value} variant={"filled"} color={color[params.value] || 'default'} />;
                }
            }
        ]);
    }

    const CustomFieldRender = ({ value }) => {
        const [isHovered, setIsHovered] = useState(false); // Add state for hover

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontSize: "13px",
                    fontWeight: "600",
                    textDecoration: isHovered ? 'underline' : 'none', // Conditionally apply underline
                }}
                onMouseEnter={() => setIsHovered(true)} // Set hover state to true on mouse enter
                onMouseLeave={() => setIsHovered(false)} // Set hover state to false on mouse leave
            >
                {value}
            </div>
        )
    }

    const dateClicked = async (start, end) => {
        setDate1(start)
        setDate2(end)

        const { getData, error } = await GetData("api/orderinfo", reload,
            { "startDate": start, "endDate": end, "menuItem": selSingleIngredient }, null, null)


        if (error) { console.log(error) }
        else if (Object.keys(getData).length === 0) {
            setLoad(false)
        }
        else {
            setLoad(false)
        }
    }

    const handleOpenEdit = (bool) => {
        if (bool) {
            setOpenEdit(true)
        }
    }

    const deleteModifier = async (bool) => {
        setDeleteOpen(false)
        if (bool) {
            const { success: modifierDeletd, error: deleteErr } = await DeleteData(`api/delete-modifier`, { "itemIds": selIngrIdArr })

            if (modifierDeletd) {
                setSelSingleIngredient(false)
                setSelIngrIdArr(null)
                setIngredientsHeader(null)
                setSelCategory(false)
                setDeleteIcon(false)
                setOpenSnackbar({ color: "success", message: "Successfully deleted item!", open: true })
                refetchMenuItems()
            }
        }
    }

    const actionOptions = (type) => {
        switch (type) {
            case "pos refresh":
                setPosOpen(true)
                break;

            case "addCatalog":
                navigate(`/inventory/create`);
                break;
            case "waste_factor":
                setOpenWasteFactor(true)
                break;
            case "copy recipe":
                setCopyRecipeOpen(true)
                break;
        }
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mr: 'auto', flexWrap: 'wrap' }}>
                    <MenuActionsButton selection={actionOptions} itemsSelected={selIngrIdArr} />
                    <button
                        className={selIngrIdArr?.length ? "delete-bttn" : "delete-dis"}
                        disabled={!selIngrIdArr?.length}
                        onClick={() => setDeleteOpen(true)}
                    >
                        <DeleteIcon sx={{ color: selIngrIdArr?.length ? tokens.danger : "#a39b92", fontSize: 18 }} />
                        <span>Delete</span>
                    </button>
                </Stack>
                <GridToolbarQuickFilter
                    variant="outlined"
                    size="small"
                    sx={quickFilterSx}
                />
            </GridToolbarContainer>
        );
    }

    const handlePOSChoice = async (bool) => {

        setPosOpen(false)
        if (bool) {
            setPosLoad(true)
            // setOpenSnackbar({ color: "success", message: "Product catalog updated successfully.", open: true })
            const { getData } = await GetData("api/updatemenu", null, null, null, null)
            if (getData) {
                //     setPosLoad(false)
                //     setNoRecipeItem(curr => ({ ...curr, ["itemNames"]: getData, ["openDialog"]: true }))
                // } else {
                setPosLoad(false)
                setOpenSnackbar({ color: "success", message: "Product catalog updated successfully.", open: true })
                refetchMenuItems()
            }

        } else {
            setPosOpen(false)
            refetchMenuItems()
        }
    }

    const selectClick = (e) => {
        if (e.length === 1) {
            // const findData = data.find((element) => e[0] === element.itemId)
            const findData = menuItemsData.find((element) => e[0] === element.posItemId || e[0] === element._id)
            console.log(findData)
            // setSelSingleIngredient(e[0])
            // setSelSingleIngredient(findData?.posItemId)
            setSelIngrIdArr(e)
            setSelCategory(findData.category)
            setIngredientsHeader(findData.itemName)
            setDeleteIcon(true)
            if (date1 && date2) {
                dateClicked(date1, date2)
            }
        } else if (e.length > 1) {
            setSelSingleIngredient(false)
            setSelIngrIdArr(e)
            setIngredientsHeader(null)
            setSelCategory(false)
        } else {
            setSelSingleIngredient(false)
            setSelIngrIdArr(null)
            setIngredientsHeader(null)
            setSelCategory(false)
            setDeleteIcon(false)
        }
    }

    const handleRowClick = (params) => {
        console.log('PARAMS:', params)
        const findData = menuItemsData.find((element) => params.id === element.posItemId || params.id === element._id)
        console.log(findData)
        // setSelSingleIngredient(findData?.posItemId)
        navigate(`/inventory/${findData?.posItemId}`);

    };

    const closeDrawer = () => {
        setSelSingleIngredient(false)
        setSelIngrIdArr(null)
        setIngredientsHeader(null)
        setSelCategory(false)
        setDeleteIcon(false)
    }

    if (load) {
        return (<div style={{ position: 'relative', top: '5em', left: "45%" }}><CircularProgress /></div>)
    }

    return (
        <>
            <Dialog fullScreen open={openAddItem} onClose={handlePopupClose}>
                <AddItem ingredientId={selSingleIngredient} itemCategory={selCategory} close={handlePopupClose} />
            </Dialog >

            <Dialog open={openEdit} onClose={handlePopupClose} fullScreen>
                <EditMenuIngredients close={handlePopupClose} ingredientId={selSingleIngredient} itemCategory={selCategory} />
            </Dialog >

            {deleteOpen && <ConfirmDelete deleteItem={deleteModifier} deleteOpen={deleteOpen} />}
            {posOpen && <RefreshPOSMenu runApi={handlePOSChoice} posOpen={posOpen} />}

            <Dialog open={openWasteFactor} onClose={() => setOpenWasteFactor(false)} maxWidth={'sm'} sx={{ '.MuiPaper-root': { width: '450px' } }}>
                <WasteFactorConf posOpen={(val) => setOpenWasteFactor(val)} />
            </Dialog >

            <Dialog open={noRecipeItem.openDialog} onClose={handlePopupClose} maxWidth={'sm'} fullWidth>
                <NoRecipeItems close={handlePopupClose} menuItemsReturned={noRecipeItem?.itemNames} />
            </Dialog >

            <Dialog fullScreen open={copyRecipeOpen} onClose={handlePopupClose} >
                <CopyMenuItemRecipes close={handlePopupClose} selIngredients={selIngrIdArr} />
            </Dialog>


            {/* <div className="row " style={{ width: "100%" }}> */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="col-12" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: `calc(100vh - 220px)` }}>
                    <DataGrid
                        checkboxSelection
                        rowSelectionModel={selIngrIdArr ?? []}
                        onRowSelectionModelChange={selectClick}
                        onRowClick={handleRowClick} // Handles row clicks
                        rows={row}
                        columns={col}
                        rowHeight={40}
                        slots={{
                            toolbar: CustomToolbar
                        }}
                        localeText={{
                            toolbarQuickFilterPlaceholder: 'SEARCH ITEMS'
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 50,
                                },
                            },
                        }}
                        sx={{
                            ...dataGridSx,
                            border: 'none',
                            height: '100%',
                        }}

                    />
                </div>

                {/* <hr /> */}

                <Drawer anchor={'bottom'} open={!!selSingleIngredient} onClose={closeDrawer}>

                    <div>
                        <IconButton
                            onClick={closeDrawer}
                            sx={{
                                position: 'absolute', width: '40px', height: '40px', top: '10px', right: '30px',
                                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                backgroundColor: 'white', zIndex: 100, "&:hover": { backgroundColor: '#f0f0f0' }
                            }}
                        >
                            <CloseIcon sx={{ cursor: 'pointer' }} />
                        </IconButton>
                    </div>
                    <div className='row' style={{ width: "100%", margin: '10px 0 0 20px' }}>
                        <div className="col-xl-10 col-lg-9 col-md-9" >
                            <p style={{ margin: '0', fontWeight: "800" }}>{ingredientsHeader} Bill of Materials:</p>
                        </div>
                        {!!selSingleIngredient &&
                            <div className='col-1' style={{ marginLeft: '75px' }}>
                                <button onClick={() => setOpenEdit(true)} className='blank-bttn' style={{ display: "flex", alignItems: 'center' }}>
                                    <EditIcon fontSize='small' sx={{ marginRight: "5px" }} />
                                    Edit
                                </button>
                            </div>
                        }
                    </div>
                    <div className="col-xl-12 col-lg-11 col-md-12 col-sm-12 " style={{ marginBottom: '75px' }}>

                        <div className="row mu-det" style={{ justifyContent: "space-around" }}>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 ing-menu-mods" style={{ overflowY: 'auto', maxHeight: '350px' }}>

                                {!!selSingleIngredient ?
                                    <DisplayIngredients ingredientId={selSingleIngredient} editMenu={handleOpenEdit} refresh={reloadData} /> :
                                    <>
                                        <strong
                                            style={{ margin: "10px 10px 0 0", fontWeight: "bold", fontSize: "large", height: "fit-content" }}>
                                            Product Recipe
                                        </strong>
                                        <p style={{ position: "relative" }}>select a product to display</p>
                                    </>
                                }

                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 ing-menu-mods" style={{ overflowY: 'auto', maxHeight: '350px', minHeight: selSingleIngredient ? '350px' : "auto" }}>

                                {!!selSingleIngredient ?
                                    <DisplayModifiers ingredientId={selSingleIngredient} editMenu={handleOpenEdit} refresh={reloadData} /> :
                                    <>
                                        <strong
                                            style={{ margin: "10px 10px 0 0", fontWeight: "bold", fontSize: "large", height: "fit-content" }}>
                                            Product Modifier/Variant Materials
                                        </strong>
                                        <p style={{ position: "relative" }}>select a product to display</p>
                                    </>
                                }

                            </div>
                        </div>

                    </div>
                </Drawer>

                {/* ------------------------------------------------------------------------------------------------------------------------------------------------
                     The start of the 2 sections within the menu for the statistics : Ingredient & the Ordered stats
                ----------------------------------------------------------------------------------------------------------------------------------------------------*/}
                {/*
                <div className="col-xl-12 col-lg-11 col-md-12 col-sm-12 " style={{ marginBottom: '75px' }}>

                    <div className="row mu-det" style={{ justifyContent: "space-around" }}>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 ing-menu-mods" style={{ overflowY: 'auto', maxHeight: '350px' }}>

                            {(selSingleIngredient !== false && selSingleIngredient !== null) ?
                                <DisplayIngredients ingredientId={selSingleIngredient} editMenu={handleOpenEdit} refresh={reloadData} /> :
                                <>
                                    <strong
                                        style={{ margin: "10px 10px 0 0", fontWeight: "bold", fontSize: "large", height: "fit-content" }}>
                                        Product Recipe
                                    </strong>
                                    <p style={{ position: "relative" }}>select a product to display</p>
                                </>
                            }

                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 ing-menu-mods" style={{ overflowY: 'auto', maxHeight: '350px', minHeight: selSingleIngredient ? '350px' : "auto" }}>

                            {(selSingleIngredient !== false && selSingleIngredient !== null) ?
                                <DisplayModifiers ingredientId={selSingleIngredient} editMenu={handleOpenEdit} refresh={reloadData} /> :
                                <>
                                    <strong
                                        style={{ margin: "10px 10px 0 0", fontWeight: "bold", fontSize: "large", height: "fit-content" }}>
                                        Product Modifier/Variant Materials
                                    </strong>
                                    <p style={{ position: "relative" }}>select a product to display</p>
                                </>
                            }

                        </div>
                    </div>

                </div>
                                   
                {/* ------------------------ Menu POS load and success message ----------------------------*/}
                <Backdrop
                    sx={{ flexDirection: 'column', color: 'rgb(31, 182, 255)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={posLoad}
                >
                    <CircularProgress color="inherit" />
                    <p style={{ marginTop: "8px", color: "#fff" }}>Downloading catalog...</p>

                </Backdrop>
                {openSnackbar.open &&
                    <SnackbarEx color={openSnackbar.color} message={openSnackbar.message} open={openSnackbar.open}
                        close={() => setOpenSnackbar({
                            color: "",
                            message: "",
                            open: false
                        })} />}
            </div >
        </>
    )
}





